import * as type from '../actions/types';

const initialState = {
    loading: false,
    error: null,
}

export default function registerEditMobile(state = initialState, action) {
    switch (action.type) {
        case type.PUT_REGISTRATION_EDIT_MOBILE_NUMBER_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.PUT_REGISTRATION_EDIT_MOBILE_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
            }
        case type.PUT_REGISTRATION_EDIT_MOBILE_NUMBER_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}